import React from 'react'
import PurchaseOrder from './PurchaseOrder'
import { Route, Routes } from 'react-router-dom';
import OrderList from './OrderList';
import ViewOrder from './ViewOrder';
import EditPurchaseOrder from './EditPurchaseOrder';

export default function OrderRoute() {
     return (
          <Routes>
               <Route path="/" element={<OrderList />} />
               <Route path="/new" element={<PurchaseOrder />} />
               <Route path="/view/:id" element={<ViewOrder />} />
               <Route path="/edit/:id" element={<EditPurchaseOrder />} />
          </Routes>
     )
}
